import { render } from "./LoginModal.vue?vue&type=template&id=c6218bdc"
import script from "./LoginModal.vue?vue&type=script&lang=js"
export * from "./LoginModal.vue?vue&type=script&lang=js"

import "./LoginModal.vue?vue&type=style&index=0&id=c6218bdc&lang=css"

import exportComponent from "/app/vendor/quizwhiz-legacy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__